import { useEffect, useState } from "react"
import ConfirmModal from "../../modal/ConfirmModal"
import ProductCardComponent from "../ProductCard/ProductCardComponent"
import { useDispatch, useSelector } from "react-redux"
import { myCart, myCartDelete, myCartDeleteClear } from "../../../redux/Cart/actions"
import { SessionKeys } from "../../../utils/AppUtils"
import _ from "lodash"
import useLogin from "../../../custom-hooks/useLogin"

const CartCardSectionComponent = (props) => {

    const dispatch = useDispatch();

    const myCartDelRes = useSelector(state => state.carts.myCartDelete);

    const [confirmModal, setConfirmModal] = useState(false)

    useEffect(() => {
        // console.log("my cart delete data record", myCartDelRes)
        if (!_.isEmpty(myCartDelRes)) {
            // props.setIsLoading(false)
            dispatch(myCartDeleteClear())
            if (myCartDelRes.status === "success") {
                if (!_.isEmpty(myCartDelRes?.payload)) {
                    
                    dispatch(myCart({
                        module: 'myCart',
                        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
                        // email: authBroker?.payload.user.email
                    }))
                }
            } else {
                alert('Unable to remove product')
            }
            
        }
    }, [myCartDelRes])

    const deleteProductFromCart = () => {
        let postData = {
            pid: props.id,
        }
        if (localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
            postData.token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
        } else {
            postData.session_id = localStorage.getItem(SessionKeys.SESSION_ID)
        }
        dispatch(myCartDelete({
            module: 'remove-product',
            postData
        }))
        setConfirmModal(false)
        props.setIsLoading(true)
    }

    const renderRemoveCart = (price) => {
        return (
            <div className="cardbtn-row">
                <div className="cart-price-box w-100">
                    <div className="cart-price">
                        {price}
                    </div>
                    <div className="d-flex justify-content-end align-items-center btn-sec-cart">
                        <button type="button" className="cart-remove-btn"
                            onClick={() => setConfirmModal(true)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="21"
                                height="20"
                                viewBox="0 0 21 20"
                                fill="none"
                            >
                                <path
                                    d="M5.91686 14.1667H14.9412C15.7328 14.1667 16.1287 14.1667 16.4513 14.0237C16.7357 13.8976 16.9791 13.6944 17.154 13.4371C17.3524 13.1453 17.4233 12.7559 17.5649 11.977L18.6905 5.78594C18.7396 5.516 18.7641 5.38103 18.7262 5.27564C18.693 5.18318 18.6281 5.10544 18.5431 5.05618C18.4462 5.00002 18.309 5.00002 18.0346 5.00002H4.66686M2.16675 1.66669H3.26375C3.46599 1.66669 3.56711 1.66669 3.64889 1.70363C3.72098 1.73619 3.7823 1.78859 3.82571 1.85471C3.87495 1.92973 3.89072 2.02961 3.92226 2.22938L6.24457 16.9373C6.27611 17.1371 6.29188 17.237 6.34112 17.312C6.38453 17.3781 6.44585 17.4305 6.51794 17.4631C6.59972 17.5 6.70084 17.5 6.90308 17.5H16.3334"
                                    stroke="#6941C6"
                                    strokeWidth="1.66667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            Remove from cart
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <ProductCardComponent {...props} footerLineComp={renderRemoveCart(props.price)} isCart={true}/>
            <ConfirmModal 
                confirmModal={confirmModal}
                setConfirmModal={setConfirmModal}
                showModalMsg={'Are you sure you want to remove ?'}
                isConfirm={true}
                confirmAction={() => deleteProductFromCart()}
                confirmId={''}
                isRightIcon={""}
            />
        </>
    )

}

export default CartCardSectionComponent